__webpack_require__.p = "/games-list/";